import { IPregunta, Pregunta } from './pregunta.model';

export interface IPaso {
  idPaso: string;
  preguntas?: IPregunta[];
}

export class Paso {
  idPaso: string;
  preguntas: Pregunta[];

  constructor(data: IPaso) {
    this.idPaso = data.idPaso;
    this.preguntas = data.preguntas 
      ? data.preguntas.map(
          p => new Pregunta(p)
        ) 
      : [];
  }
}
